import React from 'react'

const Send = ({onSend}) => {
  return (<span onClick={onSend} style={{fontSize:'25px',margin:'0 10px'}} className="mdi mdi-send" />)
}
export default Send;
